import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import Select from "react-select";
import { API_URL } from "../..";

const OvertimeFilters = ({ filters, onFilterChange }) => {
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const res = await fetch(`${API_URL}/api/user/fetch`);
        const json = await res.json();
        if (json.message === "success") setEmployees(json.data || []);
      } catch (err) {
        console.error("Fetch employees error:", err);
      }
    };
    fetchEmployees();
  }, []);

  const employeeOptions = employees.map((u) => ({
    value: u.id,
    label: u.name,
  }));

  const statusOptions = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
  ];

  const handleSelectChange = (selectedOption) => {
    onFilterChange({
      ...filters,
      userId: selectedOption ? selectedOption.value : "",
    });
  };

  const handleStatusChange = (selectedOption) => {
    onFilterChange({
      ...filters,
      status: selectedOption ? selectedOption.value : "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onFilterChange({ ...filters, [name]: value });
  };

  const handleReset = () => {
    onFilterChange({
      userId: "",
      startDate: "",
      endDate: "",
      status: "",
    });
  };

  return (
    <Form className="p-3 border rounded bg-light">
      <Row className="g-3 align-items-end">
        {/* 🧑‍💼 Employee */}
        <Col md={3}>
          <Form.Label>User</Form.Label>
          <Select
            options={employeeOptions}
            value={employeeOptions.find((opt) => opt.value === filters.userId) || null}
            onChange={handleSelectChange}
            placeholder="All Employees"
            isClearable
          />
        </Col>

        {/* 📅 Start Date */}
        <Col md={2}>
          <Form.Label>Start Date</Form.Label>
          <Form.Control
            type="date"
            name="startDate"
            value={filters.startDate}
            onChange={handleInputChange}
          />
        </Col>

        {/* 📅 End Date */}
        <Col md={2}>
          <Form.Label>End Date</Form.Label>
          <Form.Control
            type="date"
            name="endDate"
            value={filters.endDate}
            onChange={handleInputChange}
          />
        </Col>

        {/* 📊 Status */}
        <Col md={2}>
          <Form.Label>Status</Form.Label>
          <Select
            options={statusOptions}
            value={statusOptions.find((opt) => opt.value === filters.status) || statusOptions[0]}
            onChange={handleStatusChange}
            placeholder="All"
            isClearable
          />
        </Col>

        {/* 🎛 Buttons */}
        <Col md={3} className="text-end">
          <Button variant="primary" className="me-2" onClick={() => onFilterChange(filters)}>
            Apply
          </Button>
          <Button variant="outline-secondary" onClick={handleReset}>
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default OvertimeFilters;